import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm, UntypedFormGroup} from '@angular/forms';
import { StoreService } from '../../../../../services/store.service';
import { IComponent } from '../../../../../types/step-component.interface';
import { IValidationSubComponent } from '../../../../../types/subcomponent-validation.interface';
import {markAllFieldsAsTouched} from "../../../../../shared/utils";

@Component({
  selector: 'app-school-questions',
  templateUrl: 'school-questions.component.html'
})
export class SchoolQuestionsComponent implements AfterViewInit, OnInit, IValidationSubComponent {
  @Input() metadata: IComponent;
  @ViewChild('form') ngForm: NgForm;

  years: any[] = [];
  schoolForm: UntypedFormGroup;
  schoolQuestions: any;

  constructor(public storeService: StoreService) {}

  ngOnInit() {
    const state = this.storeService.getCurrentState();
    this.schoolQuestions = (state.schoolQuestions ? state.schoolQuestions : { schoolEndYear: null });

    const endYear = new Date().getFullYear() + 20;
    const startYear = 1970;
    for (let year = endYear; year >= startYear; year--) {
      this.years.push({id: year, description:year});
    }
    this.years.unshift( {id: null, description: 'Select a Year'})
  }

  ngAfterViewInit() {
    this.schoolForm = this.ngForm.form;
  }

  validate(): boolean {
    markAllFieldsAsTouched(this.schoolForm);
    return this.ngForm.valid;
  }
}
